import Head from "next/head";

export default function PreloadedStaticImg() {
	return (
		<Head>
			{/* Light mode */}
			<link
				rel="preload"
				as="image"
				media="(prefers-color-scheme: light)"
				href="https://web-cdn.rockflow.tech/h5/survey/pre-upload-passport-light.png"
			/>
			<link
				rel="preload"
				as="image"
				media="(prefers-color-scheme: light)"
				href="https://web-cdn.rockflow.tech/h5/survey/pre-upload-id-card-light.png"
			/>
			<link
				rel="preload"
				as="image"
				media="(prefers-color-scheme: light)"
				href="https://web-cdn.rockflow.tech/h5/survey/upload-back-light.png"
			/>
			<link
				rel="preload"
				as="image"
				media="(prefers-color-scheme: light)"
				href="https://web-cdn.rockflow.tech/h5/survey/upload-passport-light.png"
			/>
			<link
				rel="preload"
				as="image"
				media="(prefers-color-scheme: light)"
				href="https://web-cdn.rockflow.tech/h5/survey/upload-front-light.png"
			/>

			{/* Dark mode */}
			<link
				rel="preload"
				as="image"
				media="(prefers-color-scheme: dark)"
				href="https://web-cdn.rockflow.tech/h5/survey/pre-upload-passport-dark.png"
			/>
			<link
				rel="preload"
				as="image"
				media="(prefers-color-scheme: dark)"
				href="https://web-cdn.rockflow.tech/h5/survey/pre-upload-id-card-dark.png"
			/>
			<link
				rel="preload"
				as="image"
				media="(prefers-color-scheme: dark)"
				href="https://web-cdn.rockflow.tech/h5/survey/upload-front-dark.png"
			/>
			<link
				rel="preload"
				as="image"
				media="(prefers-color-scheme: dark)"
				href="https://web-cdn.rockflow.tech/h5/survey/upload-passport-dark.png"
			/>
			<link
				rel="preload"
				as="image"
				media="(prefers-color-scheme: dark)"
				href="https://web-cdn.rockflow.tech/h5/survey/upload-back-dark.png"
			/>

			{/* Other--adv */}
			<link
				rel="preload"
				as="image"
				media="(min-width: 1024px)"
				href="https://web-cdn.rockflow.tech/h5/survey/pc-banner/left-banner-nationality.png"
			/>
			<link
				rel="preload"
				as="image"
				media="(min-width: 1024px)"
				href="https://web-cdn.rockflow.tech/h5/survey/pc-banner/left-banner-account-name.png"
			/>
			<link
				rel="preload"
				as="image"
				media="(min-width: 1024px)"
				href="https://web-cdn.rockflow.tech/h5/survey/pc-banner/left-banner-account-finished.png"
			/>
		</Head>
	);
}
